<div class="saru-editor">
  <div class="saru-editor__header">
    <div>
      <h4 class="saru-editor__title">Configure Row #{{ row.rowNumber }}</h4>
      <p class="saru-editor__subtitle">{{ parsed.productName || parsed.brandName || 'Untitled product' }}</p>
    </div>
    <button type="button" class="saru-editor__close" (click)="cancel()" aria-label="Close">
      <i data-lucide="x"></i>
    </button>
  </div>

  <div class="saru-editor__main">
    <aside class="saru-editor__nav">
      <div class="saru-editor__nav-title">Sections</div>
      <button
        *ngFor="let t of editorTabs"
        type="button"
        class="saru-editor__nav-item"
        [class.saru-editor__nav-item--active]="activeTab === t.id"
        [class.saru-editor__nav-item--error]="hasSectionError(t.id)"
        (click)="setTab(t.id)"
      >
        <span class="saru-editor__nav-num">{{ t.id }}</span>
        <span class="saru-editor__nav-label">{{ t.short }}</span>
      </button>
    </aside>

    <div class="saru-editor__content">
      <div class="saru-editor__content-head">
        <h5 class="saru-editor__content-title">{{ activeTabLabel }}</h5>
      </div>

      <div class="saru-editor__body">
        <div class="saru-section-errors" *ngIf="sectionErrorMessages.length">
          <div class="saru-section-errors__title">Please fix the following:</div>
          <ul>
            <li *ngFor="let msg of sectionErrorMessages">{{ msg }}</li>
          </ul>
        </div>

        <!-- ========== Sec 1 Company ========== -->
        <div *ngIf="activeTab === 1" class="saru-editor__section">
          <div class="saru-field" [class.saru-field--error]="hasFieldError('companyName')">
            <label>Company Name</label>
            <input class="saru-input" [(ngModel)]="parsed.companyName" (ngModelChange)="onParsedChange('companyName')" (blur)="onFieldBlur('companyName')" placeholder="Enter registered company name" />
            <div class="saru-field__error" *ngIf="hasFieldError('companyName')">{{ getFieldError('companyName') }}</div>
          </div>
          <div class="saru-field saru-field--full" [class.saru-field--error]="hasFieldError('address')">
            <label>Address</label>
            <textarea class="saru-input" rows="2" [(ngModel)]="parsed.address" (ngModelChange)="onParsedChange('address')" (blur)="onFieldBlur('address')" placeholder="Enter plot no., street, area"></textarea>
            <div class="saru-field__error" *ngIf="hasFieldError('address')">{{ getFieldError('address') }}</div>
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('executiveOwner')">
            <label>Executive Owner</label>
            <input class="saru-input" [(ngModel)]="parsed.executiveOwner" (ngModelChange)="onParsedChange('executiveOwner')" (blur)="onFieldBlur('executiveOwner')" placeholder="Executive Owner" />
            <div class="saru-field__error" *ngIf="hasFieldError('executiveOwner')">{{ getFieldError('executiveOwner') }}</div>
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('mobileNumber')">
            <label>Mobile Number</label>
            <input class="saru-input" [(ngModel)]="parsed.mobileNumber" (ngModelChange)="onParsedChange('mobileNumber')" (blur)="onFieldBlur('mobileNumber')" placeholder="Enter mobile number" />
            <div class="saru-field__error" *ngIf="hasFieldError('mobileNumber')">{{ getFieldError('mobileNumber') }}</div>
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('email')">
            <label>Email</label>
            <input class="saru-input" type="email" [(ngModel)]="parsed.email" (ngModelChange)="onParsedChange('email')" (blur)="onFieldBlur('email')" placeholder="your@mail.com" />
            <div class="saru-field__error" *ngIf="hasFieldError('email')">{{ getFieldError('email') }}</div>
          </div>
          <div class="saru-field">
            <label>GST Status</label>
            <input class="saru-input" [(ngModel)]="parsed.gstStatus" placeholder="GST Status" />
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('countryId')">
            <label>Country</label>
            <ng-select [items]="lookups.countries" bindLabel="name" bindValue="id"
              placeholder="Select country" [(ngModel)]="selections.countryId"
              (ngModelChange)="onCompanyCountryChange()" (blur)="onFieldBlur('countryId')" [clearable]="true" appendTo="body"></ng-select>
            <div class="saru-field__error" *ngIf="hasFieldError('countryId')">{{ getFieldError('countryId') }}</div>
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('stateId')">
            <label>State</label>
            <ng-select [items]="companyStates" bindLabel="name" bindValue="id"
              placeholder="Select state" [(ngModel)]="selections.stateId"
              (ngModelChange)="onCompanyStateChange()" (blur)="onFieldBlur('stateId')" [loading]="loadingCompanyStates" [clearable]="true" appendTo="body"></ng-select>
            <div class="saru-field__error" *ngIf="hasFieldError('stateId')">{{ getFieldError('stateId') }}</div>
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('cityId')">
            <label>City</label>
            <ng-select [items]="companyCities" bindLabel="name" bindValue="id"
              placeholder="Select city" [(ngModel)]="selections.cityId"
              (ngModelChange)="onCompanyCityChange()" (blur)="onFieldBlur('cityId')" [loading]="loadingCompanyCities" [clearable]="true" appendTo="body"></ng-select>
            <div class="saru-field__error" *ngIf="hasFieldError('cityId')">{{ getFieldError('cityId') }}</div>
          </div>
          <div class="saru-field" [class.saru-field--error]="hasFieldError('pincodeId')">
            <label>Pin Code</label>
            <ng-select [items]="companyPincodeItems" bindLabel="label" bindValue="id"
              placeholder="Type pincode to auto-fill country, state and city"
              [(ngModel)]="selections.pincodeId" [searchable]="true" [typeahead]="companyPincodeTypeahead"
              [minTermLength]="3" [clearSearchOnAdd]="true"
              [loading]="loadingCompanyPincodes || searchingCompanyPincode"
              typeToSearchText="Type at least 3 digits..."
              (select)="onCompanyPincodeOptionSelected($event)"
              (change)="onCompanyPincodeSelected($event)"
              (blur)="onFieldBlur('pincodeId')"
              [clearable]="true" appendTo="body"></ng-select>
            <p class="saru-hint">Search or select a pin code to auto-fill country, state, and city.</p>
            <div class="saru-field__error" *ngIf="hasFieldError('pincodeId')">{{ getFieldError('pincodeId') }}</div>
          </div>
        </div>

    <!-- ========== Sec 2 Product ========== -->
    <div *ngIf="activeTab === 2" class="saru-editor__section">
      <div class="saru-field" [class.saru-field--error]="hasFieldError('brandName')">
        <label>Brand Name</label>
        <input class="saru-input" [(ngModel)]="parsed.brandName" (ngModelChange)="onParsedChange('brandName')" (blur)="onFieldBlur('brandName')" placeholder="Enter brand name" />
        <div class="saru-field__error" *ngIf="hasFieldError('brandName')">{{ getFieldError('brandName') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('productName')">
        <label>Product Name</label>
        <input class="saru-input" [(ngModel)]="parsed.productName" (ngModelChange)="onParsedChange('productName')" (blur)="onFieldBlur('productName')" placeholder="Enter product name" />
        <div class="saru-field__error" *ngIf="hasFieldError('productName')">{{ getFieldError('productName') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('dietaryPreferenceId')">
        <label>Dietary Preference</label>
        <ng-select [items]="lookups.dietaryPreferences" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.dietaryPreferenceId"
          (ngModelChange)="onMasterSelect('dietaryPreferenceId', lookups.dietaryPreferences)"
          (blur)="onFieldBlur('dietaryPreferenceId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('dietaryPreferenceId')">{{ getFieldError('dietaryPreferenceId') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('productForm')">
        <label>Product Form</label>
        <ng-select [items]="lookups.supplementForms" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.productForm"
          (ngModelChange)="clearFieldError('productForm'); scheduleFssaiTagRefresh()"
          (blur)="onFieldBlur('productForm')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('productForm')">{{ getFieldError('productForm') }}</div>
      </div>
      <div class="saru-field">
        <label>Available Flavour</label>
        <input class="saru-input" [(ngModel)]="parsed.availableFlavour" placeholder="e.g. Orange" />
      </div>
      <div class="saru-field saru-field--full">
        <label>Supplement Description</label>
        <textarea class="saru-input" rows="3" [(ngModel)]="parsed.supplementDescription" placeholder="Short product description"></textarea>
      </div>
      <div class="saru-field">
        <label>Brand Website</label>
        <input class="saru-input" [(ngModel)]="parsed.brandWebsite" placeholder="https://www.example.com" />
      </div>
      <div class="saru-field">
        <label>Instagram</label>
        <input class="saru-input" [(ngModel)]="parsed.instagram" placeholder="@username" />
      </div>
      <div class="saru-field">
        <label>Facebook</label>
        <input class="saru-input" [(ngModel)]="parsed.facebook" placeholder="Facebook page name" />
      </div>
      <div class="saru-field">
        <label>LinkedIn</label>
        <input class="saru-input" [(ngModel)]="parsed.linkedin" placeholder="LinkedIn company name" />
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('dataSourceId')">
        <label>Data Source</label>
        <ng-select [items]="lookups.dataSources" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.dataSourceId"
          (ngModelChange)="onMasterSelect('dataSourceId', lookups.dataSources)"
          (blur)="onFieldBlur('dataSourceId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('dataSourceId')">{{ getFieldError('dataSourceId') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('databaseSourceId')">
        <label>Database Source</label>
        <ng-select [items]="lookups.databaseSources" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.databaseSourceId"
          (ngModelChange)="onMasterSelect('databaseSourceId', lookups.databaseSources)"
          (blur)="onFieldBlur('databaseSourceId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('databaseSourceId')">{{ getFieldError('databaseSourceId') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('countryOfOriginId')">
        <label>Country of Origin</label>
        <ng-select [items]="lookups.countries" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.countryOfOriginId"
          (ngModelChange)="onMasterSelect('countryOfOriginId', lookups.countries)"
          (blur)="onFieldBlur('countryOfOriginId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('countryOfOriginId')">{{ getFieldError('countryOfOriginId') }}</div>
      </div>
      <div class="saru-field">
        <label>Shelf Life</label>
        <input class="saru-input" [(ngModel)]="parsed.shelfLife" placeholder="e.g. 24" />
      </div>
      <div class="saru-field">
        <label>Shelf Life Unit</label>
        <ng-select [items]="shelfLifeUnits" [(ngModel)]="selections.shelfLifeUnit" [clearable]="true" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Data Capturing Date</label>
        <input class="saru-input" type="date" [(ngModel)]="parsed.dataCapturingDate" />
      </div>
      <div class="saru-field">
        <label>Date of Manufacturing</label>
        <input class="saru-input" type="date" [(ngModel)]="parsed.dateOfManufacturing" />
      </div>
      <div class="saru-field">
        <label>Date of Expiry</label>
        <input class="saru-input" type="date" [(ngModel)]="parsed.dateOfExpiry" />
      </div>
      <div class="saru-field">
        <label>Best Before Date</label>
        <input class="saru-input" type="date" [(ngModel)]="parsed.bestBeforeDate" />
      </div>
      <div class="saru-field">
        <label>Net Quantity</label>
        <input class="saru-input" [(ngModel)]="parsed.netQuantity" placeholder="Enter value" />
      </div>
      <div class="saru-field">
        <label>Net Quantity Unit</label>
        <ng-select [items]="netQtyUnits" [(ngModel)]="selections.netQuantityUnit" [clearable]="true" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Lot Number</label>
        <input class="saru-input" [(ngModel)]="parsed.lotNumber" placeholder="LOT-2024-001" />
      </div>
      <div class="saru-field">
        <label>Reference URL</label>
        <input class="saru-input" [(ngModel)]="parsed.referenceUrl" placeholder="https://example.com" />
      </div>
      <p class="saru-hint">Product images (Front/Back/Left/Right) can be uploaded from the preview table (Front) or after create in the full form.</p>
    </div>

    <!-- ========== Sec 3 Entities ========== -->
    <div *ngIf="activeTab === 3" class="saru-editor__section">
      <ng-container *ngFor="let e of section3EntityDefs">
        <div class="saru-entity-block">
          <h5 class="saru-entity-block__title">{{ e.label }}</h5>
          <div class="saru-field">
            <label>Name</label>
            <input class="saru-input" [ngModel]="getParsedText(e.nameKey)" (ngModelChange)="setParsedText(e.nameKey, $event)" [ngModelOptions]="{standalone: true}" placeholder="Enter entity name" />
          </div>
          <div class="saru-field saru-field--full">
            <label>Address</label>
            <textarea class="saru-input" rows="2" [ngModel]="getParsedText(e.addressKey)" (ngModelChange)="setParsedText(e.addressKey, $event)" [ngModelOptions]="{standalone: true}" placeholder="Enter plot no., street, area"></textarea>
          </div>
          <div class="saru-field">
            <label>License No</label>
            <input class="saru-input" [ngModel]="getParsedText(e.licenseKey)" (ngModelChange)="setParsedText(e.licenseKey, $event)" [ngModelOptions]="{standalone: true}" placeholder="Enter license no." />
          </div>
          <ng-container *ngTemplateOutlet="entityLocationTpl; context: { $implicit: e.key }"></ng-container>
        </div>
      </ng-container>
    </div>

    <!-- ========== Sec 4 Import/Export REMOVED ========== -->
    <div *ngIf="false" class="saru-editor__section">
      <ng-container *ngFor="let e of section4EntityDefs">
        <div class="saru-entity-block">
          <h5 class="saru-entity-block__title">{{ e.label }}</h5>
          <div class="saru-field">
            <label>Name</label>
            <input class="saru-input" [ngModel]="getParsedText(e.nameKey)" (ngModelChange)="setParsedText(e.nameKey, $event)" [ngModelOptions]="{standalone: true}" placeholder="Enter entity name" />
          </div>
          <div class="saru-field saru-field--full">
            <label>Address</label>
            <textarea class="saru-input" rows="2" [ngModel]="getParsedText(e.addressKey)" (ngModelChange)="setParsedText(e.addressKey, $event)" [ngModelOptions]="{standalone: true}" placeholder="Enter plot no., street, area"></textarea>
          </div>
          <div class="saru-field">
            <label>License No</label>
            <input class="saru-input" [ngModel]="getParsedText(e.licenseKey)" (ngModelChange)="setParsedText(e.licenseKey, $event)" [ngModelOptions]="{standalone: true}" placeholder="Enter license no." />
          </div>
          <ng-container *ngTemplateOutlet="entityLocationTpl; context: { $implicit: e.key }"></ng-container>
        </div>
      </ng-container>
    </div>

    <!-- ========== Sec 5 SKU ========== -->
    <div *ngIf="activeTab === 4" class="saru-editor__section">
      <button type="button" class="btn btn--outline btn-sm mb-2" (click)="addSkuRow()">+ Add SKU</button>
      <div *ngFor="let sku of selections.skuDetails; let i = index" class="saru-entity-block">
        <div class="saru-entity-block__title">SKU {{ i + 1 }}
          <button type="button" class="btn btn-link text-danger btn-sm" (click)="removeSkuRow(i)">Remove</button>
        </div>
        <div class="saru-field"><label>SKU Name</label><input class="saru-input" [(ngModel)]="sku.name" placeholder="e.g. 250g pack" /></div>
        <div class="saru-field"><label>Net Weight</label><input class="saru-input" [(ngModel)]="sku.netWeight" placeholder="e.g. 500" /></div>
        <div class="saru-field">
          <label>Unit</label>
          <ng-select [items]="lookups.units" bindLabel="name" bindValue="id" [(ngModel)]="sku.unitId"
            (ngModelChange)="onSkuUnitChange(sku)" [clearable]="true" appendTo="body"></ng-select>
        </div>
        <div class="saru-field">
          <label>Country</label>
          <ng-select [items]="lookups.countries" bindLabel="name" bindValue="id" [(ngModel)]="sku.countryId"
            (ngModelChange)="onSkuCountryChange(sku)" [clearable]="true" appendTo="body"></ng-select>
        </div>
        <div class="saru-field"><label>MRP</label><input class="saru-input" [(ngModel)]="sku.mrp" placeholder="e.g. 199.00" /></div>
        <div class="saru-field"><label>Manufactured by</label><input class="saru-input" [(ngModel)]="sku.manufacturedBy" /></div>
        <div class="saru-field"><label>Marketed by</label><input class="saru-input" [(ngModel)]="sku.marketedBy" /></div>
        <div class="saru-field"><label>Packaged by</label><input class="saru-input" [(ngModel)]="sku.packagedBy" /></div>
      </div>
      <p class="saru-hint" *ngIf="!selections.skuDetails.length">No SKU rows yet. Click Add SKU or provide SKUDetails in CSV.</p>
    </div>

    <!-- ========== Sec 6 Categories + Sensory + Geo + Allergens ========== -->
    <div *ngIf="activeTab === 5" class="saru-editor__section saru-editor__section--ingredients">
      <h6 class="saru-subheading">FSSAI / E-Store</h6>
      <div class="saru-merged-grid">
        <div class="saru-field">
          <label>FSSAI Category</label>
          <ng-select [items]="lookups.fssaiCategories" bindLabel="name" bindValue="id"
            [(ngModel)]="selections.fssaiCategoryId"
            (ngModelChange)="onMasterSelect('fssaiCategoryId', lookups.fssaiCategories)"
            [clearable]="true" appendTo="body"></ng-select>
        </div>
        <div class="saru-field">
          <label>E-Store Category</label>
          <ng-select [items]="lookups.eStoreCategories" bindLabel="name" bindValue="id"
            [(ngModel)]="selections.eStoreCategoryId"
            (ngModelChange)="onMasterSelect('eStoreCategoryId', lookups.eStoreCategories)"
            [clearable]="true" appendTo="body"></ng-select>
        </div>
      </div>
      <p class="saru-hint mb-3">Sub / sub-sub category cascades can be refined in the full product form after import if masters are hierarchical.</p>

      <h6 class="saru-subheading">Sensory</h6>
      <div class="saru-merged-grid">
        <div class="saru-field"><label>Taste</label>
          <ng-select [items]="lookups.tastes" bindLabel="name" bindValue="id" [(ngModel)]="selections.tasteIds"
            [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
        </div>
        <div class="saru-field"><label>Flavour</label>
          <ng-select [items]="lookups.flavours" bindLabel="name" bindValue="id" [(ngModel)]="selections.flavourIds"
            [multiple]="true" [closeOnSelect]="false" appendTo="body"></ng-select>
        </div>
      </div>


      <h6 class="saru-subheading mt-3">Allergens & Intolerance</h6>
      <div class="saru-merged-grid">
        <div class="saru-field"><label>Allergen Declared</label>
          <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [(ngModel)]="selections.allergenDeclaredIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="saru-field"><label>Additional notes (Declared)</label>
          <textarea class="saru-input" rows="2" [(ngModel)]="parsed.allergenDeclaredNotes" maxlength="250"></textarea>
        </div>
        <div class="saru-field"><label>May Contain</label>
          <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [(ngModel)]="selections.mayContainIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="saru-field"><label>Additional notes (May Contain)</label>
          <textarea class="saru-input" rows="2" [(ngModel)]="parsed.mayContainNotes" maxlength="250"></textarea>
        </div>
        <div class="saru-field"><label>Produced in Facility</label>
          <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [(ngModel)]="selections.producedInFacilityIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="saru-field"><label>Additional notes (Facility)</label>
          <textarea class="saru-input" rows="2" [(ngModel)]="parsed.producedInFacilityNotes" maxlength="250"></textarea>
        </div>
        <div class="saru-field"><label>Allergens (Contains)</label>
          <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [(ngModel)]="selections.allergenContainsIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="saru-field"><label>Allergens (Free)</label>
          <ng-select class="saru-multi-select" [items]="lookups.allergenFree" bindLabel="name" bindValue="id" [(ngModel)]="selections.allergenFreeIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergenFree, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="saru-field"><label>Intolerances (Contains)</label>
          <ng-select class="saru-multi-select" [items]="lookups.intolerances" bindLabel="name" bindValue="id" [(ngModel)]="selections.intoleranceContainsIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.intolerances, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="saru-field"><label>Intolerances (Free)</label>
          <ng-select class="saru-multi-select" [items]="lookups.intoleranceFree" bindLabel="name" bindValue="id" [(ngModel)]="selections.intoleranceFreeIds"
            [multiple]="true" [closeOnSelect]="false" [compareWith]="compareById"
            appendTo="body" [dropdownPosition]="'bottom'">
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span class="ng-value-label">{{ resolveOptionLabel(lookups.intoleranceFree, item) }}</span>
              <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <!-- ========== Sec 7 UOM REMOVED ========== -->
    <div *ngIf="false" class="saru-editor__section saru-editor__section--ingredients">
      <div class="saru-toolbar-row justify-content-end">
        <button type="button" class="btn btn--primary btn-sm" (click)="addServingMeasurement()">
          <i data-lucide="plus"></i> Add Supplement UOM
        </button>
      </div>

      <div class="uom-filter-chips" *ngIf="uomFilterChips.length">
        <button type="button" class="uom-filter-chip" [class.is-active]="!selectedUomFilter"
          (click)="setUomFilter(null)">All</button>
        <button type="button" class="uom-filter-chip" *ngFor="let name of uomFilterChips"
          [class.is-active]="selectedUomFilter === name" (click)="setUomFilter(name)">
          <i data-lucide="check" *ngIf="selectedUomFilter === name"></i>
          {{ name }}
        </button>
      </div>

      <div class="table-responsive mt-2">
        <table class="measurement-premium-table">
          <thead>
            <tr>
              <th style="width:40px">#</th>
              <th style="width:56px">Icon</th>
              <th>Serving size</th>
              <th>Serving measure</th>
              <th>Amount</th>
              <th>Unit</th>
              <th>Calories (kcal)</th>
              <th>Carbs (gm)</th>
              <th>Protein (gm)</th>
              <th>Fat (gm)</th>
              <th>Fiber (gm)</th>
              <th style="width:70px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of filteredServingMeasurements; let i = index">
              <td>{{ i + 1 }}</td>
              <td>
                <div class="unit-icon-box" [style.backgroundColor]="getMeasurementUomTheme(u).iconBg">
                  <span class="unit-icon-box__glyph" [style.color]="getMeasurementUomTheme(u).iconColor"
                    [innerHTML]="getMeasurementUomIconMarkup(u)"></span>
                </div>
              </td>
              <td><input class="saru-input saru-input--compact" [(ngModel)]="u.servingSize" /></td>
              <td class="cell-text">{{ u.servingMeasure || u.categoryName || '—' }}</td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="u.amount" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" [(ngModel)]="u.unit" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="u.calories" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="u.carbs" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="u.protein" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="u.fat" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="u.fiber" /></td>
              <td>
                <button type="button" class="saru-icon-btn saru-icon-btn--danger" (click)="removeServingMeasurementRow(u)" title="Delete">
                  <i class="ft-trash-2"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredServingMeasurements.length">
              <td colspan="12" class="saru-hint text-center py-4">
                No UOM added yet. Click Add Supplement UOM and select a category.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ========== Sec 10 Ingredients ========== -->
    <div *ngIf="activeTab === 6" class="saru-editor__section saru-editor__section--ingredients">
      <button type="button" class="btn btn--primary btn-sm mb-3" (click)="openIngredientDialog()">
        <i data-lucide="plus"></i> Add Ingredient
      </button>

      <div *ngIf="selections.ingredientDrafts.length && !selections.ingredients.length" class="saru-csv-hint">
        <strong>From CSV (draft):</strong>
        <div *ngFor="let d of selections.ingredientDrafts" class="mt-1">
          {{ d.name }} — {{ d.amount }} {{ d.unit }}
        </div>
        <p class="mb-0 mt-2">Search and add each ingredient from master to finalize.</p>
      </div>

      <div class="table-responsive" *ngIf="selections.ingredients.length">
        <table class="measurement-premium-table">
          <thead>
            <tr>
              <th style="width:40px">#</th>
              <th>Name</th>
              <th style="width:100px">Amount</th>
              <th>Unit</th>
              <th style="width:90px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ing of selections.ingredients; let i = index">
              <td>{{ i + 1 }}</td>
              <td>
                <strong>{{ ing.name }}</strong>
                <span *ngIf="!ing.ingredientId" class="saru-hint d-block">From file — link to master to save as ingredient</span>
              </td>
              <td>{{ ing.amount }}</td>
              <td><span class="ing-unit-chip">{{ formatIngredientUnit(ing.unit) }}</span></td>
              <td class="text-nowrap">
                <button type="button" class="saru-icon-btn" (click)="openIngredientDialog(i)" title="Edit">
                  <i class="ft-edit-2"></i>
                </button>
                <button type="button" class="saru-icon-btn saru-icon-btn--danger" (click)="removeIngredient(i)" title="Remove">
                  <i class="ft-trash-2"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="!selections.ingredients.length" class="saru-hint">
        No ingredients yet. Free-text from the file is accepted; click Add Ingredient to link masters.
      </div>
    </div>

    
    <!-- ========== Sec 7 Recommended Dosage ========== -->
    <div *ngIf="activeTab === 7" class="saru-editor__section">
      <div class="saru-field" [class.saru-field--error]="hasFieldError('recommendedDosageAmount')">
        <label>Recommended Dosage Amount</label>
        <input class="saru-input" type="number" [(ngModel)]="selections.recommendedDosageAmount"
          (ngModelChange)="clearFieldError('recommendedDosageAmount')"
          (blur)="onFieldBlur('recommendedDosageAmount')" placeholder="e.g. 1" />
        <div class="saru-field__error" *ngIf="hasFieldError('recommendedDosageAmount')">{{ getFieldError('recommendedDosageAmount') }}</div>
      </div>
      <div class="saru-field" [class.saru-field--error]="hasFieldError('recommendedDosageUnitId')">
        <label>Dosage Unit</label>
        <ng-select [items]="lookups.dosageUnits" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.recommendedDosageUnitId"
          (ngModelChange)="clearFieldError('recommendedDosageUnitId')"
          (blur)="onFieldBlur('recommendedDosageUnitId')"
          [clearable]="true" appendTo="body"></ng-select>
        <div class="saru-field__error" *ngIf="hasFieldError('recommendedDosageUnitId')">{{ getFieldError('recommendedDosageUnitId') }}</div>
      </div>
      <div class="saru-field saru-field--full">
        <label>Dosage Note</label>
        <textarea class="saru-input" rows="2" [(ngModel)]="selections.recommendedDosageNote" placeholder="e.g. Once daily after meal"></textarea>
      </div>
    </div>

    <!-- ========== Sec 8 Allergens ========== -->
    <div *ngIf="activeTab === 8" class="saru-editor__section">
      <p class="saru-hint">Select allergen / intolerance IDs. Notes may also come from CSV.</p>
      <div class="saru-field">
        <label>Allergen Declared</label>
        <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.allergenDeclaredIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>May Contain</label>
        <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.mayContainIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>Produced In Facility</label>
        <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.producedInFacilityIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>Allergens (Contains)</label>
        <ng-select class="saru-multi-select" [items]="lookups.allergens" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.allergenContainsIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergens, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>Allergen Free</label>
        <ng-select class="saru-multi-select" [items]="lookups.allergenFree" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.allergenFreeIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.allergenFree, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>Intolerance Contains</label>
        <ng-select class="saru-multi-select" [items]="lookups.intolerances" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.intoleranceContainsIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.intolerances, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>Intolerance Free</label>
        <ng-select class="saru-multi-select" [items]="lookups.intoleranceFree" bindLabel="name" bindValue="id" [multiple]="true"
          [(ngModel)]="selections.intoleranceFreeIds" [clearable]="true" [compareWith]="compareById"
          [closeOnSelect]="false" appendTo="body" [dropdownPosition]="'bottom'">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ resolveOptionLabel(lookups.intoleranceFree, item) }}</span>
            <span class="ng-value-icon left" (click)="clear(item); $event.stopPropagation()">×</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="saru-field">
        <label>Allergen Declared Notes</label>
        <textarea class="saru-input" rows="2" [(ngModel)]="parsed.allergenDeclaredNotes"></textarea>
      </div>
      <div class="saru-field">
        <label>May Contain Notes</label>
        <textarea class="saru-input" rows="2" [(ngModel)]="parsed.mayContainNotes"></textarea>
      </div>
      <div class="saru-field">
        <label>Produced In Facility Notes</label>
        <textarea class="saru-input" rows="2" [(ngModel)]="parsed.producedInFacilityNotes"></textarea>
      </div>
    </div>

    <!-- ========== Sec 11 Auth note ========== -->
    <div *ngIf="activeTab === 11" class="saru-editor__section">
      <p class="saru-hint">Certificate/license images are uploaded on the preview table.</p>
      <div class="saru-field">
        <label>Authorized Certificate</label>
        <ng-select [items]="lookups.certificateOptions" bindLabel="name" bindValue="id"
          [clearable]="true" appendTo="body" placeholder="Select certificate master"></ng-select>
      </div>
      <div class="saru-field">
        <label>Authorized License</label>
        <ng-select [items]="lookups.licenseOptions" bindLabel="name" bindValue="id"
          [clearable]="true" appendTo="body" placeholder="Select license master"></ng-select>
      </div>
    </div>
<!-- ========== Sec 9 Nutrients ========== -->
    <div *ngIf="activeTab === 9" class="saru-editor__section saru-editor__section--ingredients">
      <div class="saru-toolbar-row">
        <div class="saru-field saru-field--macro-picker">
          <label>Add macronutrient</label>
          <ng-select
            class="macro-picker-select"
            [items]="standardMacroOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedMacroToAdd"
            (ngModelChange)="onAddStandardMacro($event)"
            placeholder="Select macronutrient"
            [clearable]="true"
            [searchable]="true"
            appendTo="body"
          ></ng-select>
        </div>
      </div>

      <div class="table-responsive mt-2">
        <table class="measurement-premium-table measurement-premium-table--nutrients">
          <thead>
            <tr>
              <th style="min-width:140px">Macronutrient</th>
              <th style="min-width:180px">Unit</th>
              <th style="width:110px">Amount</th>
              <th style="width:100px">% DV</th>
              <th style="width:100px">RDA</th>
              <th style="width:56px"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let n of selections.macronutrients; let i = index">
              <td><strong>{{ n.nutrientName || '—' }}</strong></td>
              <td>
                <ng-select
                  class="unit-select-wide"
                  [items]="nutrientUnitOptions"
                  bindLabel="name"
                  bindValue="id"
                  [(ngModel)]="n.unitId"
                  (ngModelChange)="onMacroUnitChange(i)"
                  placeholder="Select unit"
                  [clearable]="true"
                  [searchable]="true"
                  appendTo="body"
                  [dropdownPosition]="'auto'"
                ></ng-select>
              </td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="n.amount" (ngModelChange)="scheduleFssaiTagRefresh()" placeholder="0.0" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="n.percentDV" placeholder="0" /></td>
              <td><input class="saru-input saru-input--compact saru-input--num" type="number" [(ngModel)]="n.rda" placeholder="0" /></td>
              <td>
                <button type="button" class="saru-icon-btn saru-icon-btn--danger"
                  (click)="removeMacronutrient(i); scheduleFssaiTagRefresh()" title="Remove">
                  <i class="ft-trash-2"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!selections.macronutrients.length">
              <td colspan="6" class="saru-hint">Choose a macronutrient from the dropdown — it will be added automatically.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="fssai-generated-tags mt-3">
        <label class="form-label mb-1">FSSAI Nutrient Tags (auto-generated)</label>
        <p class="saru-hint mb-2">Based on supplement product form (mapped to Solid/Liquid) and macronutrient values above.</p>
        <div class="fssai-generated-tags__chips">
          <span class="saru-hint" *ngIf="loadingFssaiTags">Calculating tags…</span>
          <ng-container *ngIf="!loadingFssaiTags && selections.generatedFssaiNutrientTags?.length">
            <span class="fssai-generated-tag-chip fssai-generated-tag-chip--default"
              *ngFor="let tag of selections.generatedFssaiNutrientTags">{{ tag.fssaiTagName }}</span>
          </ng-container>
          <span class="saru-hint" *ngIf="!loadingFssaiTags && !selections.generatedFssaiNutrientTags?.length">
            No FSSAI tags matched the current nutrient profile.
          </span>
        </div>
      </div>
    </div>

    <!-- ========== Sec 10 Health + Claims + Benefits ========== -->
    <div *ngIf="activeTab === 10" class="saru-editor__section saru-editor__section--ingredients">
      <h6 class="saru-subheading">Health Condition Tags</h6>
      <div class="saru-toolbar-row">
        <input class="saru-input" style="max-width:280px" placeholder="Search nutrient groups..."
          [(ngModel)]="healthGroupSearch" />
        <span class="saru-hint" *ngIf="filteredHealthGroups.length">{{ filteredHealthGroups.length }} group(s)</span>
        <button type="button" class="btn btn--primary btn-sm ml-auto" (click)="openHealthGroupModal()">
          <i data-lucide="plus"></i> Add Group
        </button>
      </div>

      <div class="table-responsive mt-3">
        <table class="measurement-premium-table">
          <thead>
            <tr>
              <th>Nutrient Group</th>
              <th>Tags</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of filteredHealthGroups">
              <td><strong>{{ g.groupName }}</strong></td>
              <td>
                <div class="fssai-generated-tags__chips" *ngIf="g.tags?.length">
                  <span class="fssai-generated-tag-chip fssai-generated-tag-chip--default"
                    *ngFor="let t of getVisibleHealthTags(g)">
                    {{ t.name }}
                    <button type="button" class="chip-x" (click)="removeHealthTag(g, t.id)">×</button>
                  </span>
                  <button type="button" class="btn btn-link btn-sm p-0"
                    *ngIf="g.tags.length > 6 && !isHealthExpanded(g.groupId)"
                    (click)="toggleHealthExpanded(g.groupId)">View more (+{{ g.tags.length - 6 }})</button>
                  <button type="button" class="btn btn-link btn-sm p-0"
                    *ngIf="g.tags.length > 6 && isHealthExpanded(g.groupId)"
                    (click)="toggleHealthExpanded(g.groupId)">View less</button>
                </div>
                <span class="saru-hint" *ngIf="!g.tags?.length">No tags for this group</span>
              </td>
              <td>
                <button type="button" class="btn btn-link text-danger btn-sm" (click)="removeHealthGroup(g)">Remove</button>
              </td>
            </tr>
            <tr *ngIf="!selections.healthConditionTags.length">
              <td colspan="3" class="saru-hint">No nutrient groups added. Click Add Group to select groups. Tags load automatically.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h6 class="saru-subheading mt-4">Product Claims</h6>
      <div class="saru-toolbar-row justify-content-end">
        <button type="button" class="btn btn--primary btn-sm" (click)="addClaim('product')">
          <i data-lucide="plus"></i> Add
        </button>
      </div>
      <div class="table-responsive mt-2">
        <table class="measurement-premium-table">
          <thead>
            <tr>
              <th>Claim Category</th>
              <th>Claims</th>
              <th>Tags</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of selections.productClaims; let i = index">
              <td>
                <ng-select [items]="lookups.claimTypes" bindLabel="name" bindValue="id"
                  [(ngModel)]="c.claimTypeId" (ngModelChange)="onClaimTypeChange('product', i)"
                  [compareWith]="compareById"
                  placeholder="Select claim category" [clearable]="true" appendTo="body"
                  [searchable]="true" [dropdownPosition]="'bottom'" [disabled]="!!c.isDone"></ng-select>
              </td>
              <td>
                <input class="saru-input" [(ngModel)]="c.claimText" placeholder="Enter product claim text" [readonly]="!!c.isDone" />
              </td>
              <td>
                <ng-select [items]="c.availableTags || []" bindLabel="name" bindValue="id"
                  [(ngModel)]="c.selectedTagIds" (ngModelChange)="onClaimTagsChange('product', i)"
                  [compareWith]="compareById"
                  [multiple]="true" [closeOnSelect]="false" placeholder="Select claim tags"
                  appendTo="body" [searchable]="true" [dropdownPosition]="'bottom'"
                  [disabled]="!!c.isDone || !c.claimTypeId"></ng-select>
              </td>
              <td class="text-nowrap">
                <button type="button" class="btn btn-link btn-sm text-success" *ngIf="!c.isDone" (click)="c.isDone = true" title="Done">✓</button>
                <button type="button" class="btn btn-link btn-sm" *ngIf="c.isDone" (click)="c.isDone = false" title="Edit">✎</button>
                <button type="button" class="btn btn-link text-danger btn-sm" (click)="removeClaim('product', i)">🗑</button>
              </td>
            </tr>
            <tr *ngIf="!selections.productClaims.length">
              <td colspan="4" class="saru-hint">No product claim rows. Click Add to create one.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h6 class="saru-subheading mt-4">Product Benefit</h6>
      <div class="saru-toolbar-row justify-content-end">
        <button type="button" class="btn btn--primary btn-sm" (click)="addClaim('benefit')">
          <i data-lucide="plus"></i> Add
        </button>
      </div>
      <div class="table-responsive mt-2">
        <table class="measurement-premium-table">
          <thead>
            <tr>
              <th>Product Benefit</th>
              <th>Claims</th>
              <th>Tags</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of selections.productBenefitClaims; let i = index">
              <td>
                <ng-select [items]="lookups.productBenefits" bindLabel="name" bindValue="id"
                  [(ngModel)]="c.claimTypeId" (ngModelChange)="onClaimTypeChange('benefit', i)"
                  [compareWith]="compareById"
                  placeholder="Select product benefit" [clearable]="true" appendTo="body"
                  [searchable]="true" [dropdownPosition]="'bottom'" [disabled]="!!c.isDone"></ng-select>
              </td>
              <td>
                <input class="saru-input" [(ngModel)]="c.claimText" placeholder="Enter benefit claim text" [readonly]="!!c.isDone" />
              </td>
              <td>
                <ng-select [items]="c.availableTags || []" bindLabel="name" bindValue="id"
                  [(ngModel)]="c.selectedTagIds" (ngModelChange)="onClaimTagsChange('benefit', i)"
                  [compareWith]="compareById"
                  [multiple]="true" [closeOnSelect]="false" placeholder="Select benefit tags"
                  appendTo="body" [searchable]="true" [dropdownPosition]="'bottom'"
                  [disabled]="!!c.isDone || !c.claimTypeId"></ng-select>
              </td>
              <td class="text-nowrap">
                <button type="button" class="btn btn-link btn-sm text-success" *ngIf="!c.isDone" (click)="c.isDone = true">✓</button>
                <button type="button" class="btn btn-link btn-sm" *ngIf="c.isDone" (click)="c.isDone = false">✎</button>
                <button type="button" class="btn btn-link text-danger btn-sm" (click)="removeClaim('benefit', i)">🗑</button>
              </td>
            </tr>
            <tr *ngIf="!selections.productBenefitClaims.length">
              <td colspan="4" class="saru-hint">No product benefit rows. Click Add to create one.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="activeTab === 10" class="saru-editor__section">
      <button type="button" class="btn btn--outline btn-sm mb-2" (click)="addClaim('ingredient')">+ Add Claim</button>
      <div *ngFor="let c of selections.ingredientClaims; let i = index" class="saru-entity-block">
        <div class="saru-entity-block__title">Claim {{ i + 1 }}
          <button type="button" class="btn btn-link text-danger btn-sm" (click)="removeClaim('ingredient', i)">Remove</button>
        </div>
        <div class="saru-field"><label>Claim Category</label><input class="saru-input" [(ngModel)]="c.claimTypeName" /></div>
        <div class="saru-field"><label>Claims</label><textarea class="saru-input" rows="2" [(ngModel)]="c.claimText"></textarea></div>
      </div>
    </div>

    <!-- ========== Sec 12 Rework REMOVED ========== -->
    <div *ngIf="false" class="saru-editor__section">
      <div class="saru-field">
        <label>Rework Suggestion</label>
        <ng-select [items]="lookups.reworkSuggestions" bindLabel="name" bindValue="id"
          [(ngModel)]="selections.reworkSuggestionId"
          (ngModelChange)="onMasterSelect('reworkSuggestionId', lookups.reworkSuggestions)"
          [clearable]="true" appendTo="body"></ng-select>
      </div>
      <div class="saru-field">
        <label>Description</label>
        <textarea class="saru-input" rows="3" [(ngModel)]="parsed.reworkDescription" maxlength="500" placeholder="Enter description..."></textarea>
      </div>
    </div>

    <div *ngIf="activeTab === 12" class="saru-editor__section saru-editor__section--ingredients">
      <div class="saru-field saru-field--full">
        <label>Direction for Use</label>
        <textarea class="saru-input" rows="4" [(ngModel)]="parsed.directionForUse" maxlength="500" placeholder="Enter direction for use..."></textarea>
      </div>
      <div class="saru-field saru-field--full">
        <label>Warnings</label>
        <textarea class="saru-input" rows="4" [(ngModel)]="parsed.warnings" maxlength="500" placeholder="Enter warnings..."></textarea>
      </div>
      <div class="saru-field saru-field--full">
        <label>Disclaimer</label>
        <textarea class="saru-input" rows="4" [(ngModel)]="parsed.disclaimer" maxlength="500" placeholder="Enter disclaimer..."></textarea>
      </div>
    </div>

    <!-- Status -->
    <div *ngIf="activeTab === 13" class="saru-editor__section">
      <div class="saru-field" [class.saru-field--error]="hasFieldError('assignment')">
        <label>Status</label>
        <ng-select [items]="statusOptions" bindLabel="label" bindValue="value"
          [(ngModel)]="selections.status" [clearable]="false" appendTo="body"></ng-select>
        <p class="saru-hint">Default is Draft. Choosing Assigned to Maker/Checker opens the assign dialog after save.</p>
        <div class="saru-field__error" *ngIf="hasFieldError('assignment')">{{ getFieldError('assignment') }}</div>
      </div>
      <div class="saru-field" *ngIf="selections.assignment">
        <label>Assignment</label>
        <div class="saru-readonly">
          Mode: {{ selections.assignment.mode }}
          <span *ngIf="selections.assignment.makerEmail"> · Maker: {{ selections.assignment.makerEmail }}</span>
          <span *ngIf="selections.assignment.checkerEmail"> · Checker: {{ selections.assignment.checkerEmail }}</span>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div>

  <div class="saru-editor__footer">
    <button type="button" class="btn btn--outline" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn--primary" (click)="save()">
      <i data-lucide="check"></i>
      Save Configuration
    </button>
  </div>
</div>

<!-- Shared entity location fields -->
<ng-template #entityLocationTpl let-key>
  <div class="saru-field">
    <label>Country</label>
    <ng-select [items]="lookups.countries" bindLabel="name" bindValue="id"
      [(ngModel)]="selections[key].countryId"
      (ngModelChange)="onEntityCountryChange(key)"
      [clearable]="true" appendTo="body"></ng-select>
  </div>
  <div class="saru-field">
    <label>State</label>
    <ng-select [items]="entityStateOptions[key] || []" bindLabel="name" bindValue="id"
      [(ngModel)]="selections[key].stateId"
      (ngModelChange)="onEntityStateChange(key)"
      [clearable]="true" appendTo="body"></ng-select>
  </div>
  <div class="saru-field">
    <label>City</label>
    <ng-select [items]="entityCityOptions[key] || []" bindLabel="name" bindValue="id"
      [(ngModel)]="selections[key].cityId"
      (ngModelChange)="onEntityCityChange(key)"
      [clearable]="true" appendTo="body"></ng-select>
  </div>
  <div class="saru-field">
    <label>Pin Code</label>
    <ng-select [items]="entityPincodeItems[key] || []" bindLabel="label" bindValue="id"
      placeholder="Type pincode to auto-fill location"
      [(ngModel)]="selections[key].pincodeId"
      [searchable]="true" [typeahead]="entityPincodeTypeahead[key]"
      [minTermLength]="3" [clearSearchOnAdd]="true"
      [loading]="entitySearchingPincode[key]"
      typeToSearchText="Type at least 3 digits..."
      (select)="onEntityPincodeOptionSelected(key, $event)"
      (change)="onEntityPincodeSelected(key, $event)"
      [clearable]="true" appendTo="body"></ng-select>
  </div>
</ng-template>

<!-- Ingredient dialog -->
<ng-template #ingredientDialogTpl let-modal>
  <div class="saru-subdialog">
    <div class="saru-subdialog__header">
      <div class="saru-subdialog__header-icon"><i data-lucide="leaf"></i></div>
      <h5 class="saru-subdialog__title">{{ ingredientEditIndex != null ? 'Edit' : 'Add' }} Ingredient</h5>
      <button type="button" class="saru-subdialog__close" (click)="closeIngredientDialog()" aria-label="Close">
        <i data-lucide="x"></i>
      </button>
    </div>
    <div class="saru-subdialog__body">
      <div class="ingredient-field">
        <label class="ingredient-field__label">Ingredient</label>
        <ng-select
          [items]="ingredientSearchResults"
          bindLabel="name"
          bindValue="id"
          [(ngModel)]="selectedIngredientId"
          [typeahead]="ingredientTypeahead"
          [minTermLength]="2"
          [loading]="ingredientSearchLoading"
          placeholder="Search ingredient (min 2 characters)..."
          notFoundText="No items found"
          typeToSearchText="Type to search ingredients..."
          (change)="onIngredientPicked($event)"
          appendTo="body"
        ></ng-select>
      </div>
      <div class="ingredient-field-row">
        <div class="ingredient-field ingredient-field--half">
          <label class="ingredient-field__label">Amount</label>
          <input class="ingredient-input" type="number" [(ngModel)]="ingredientAmount" min="0" step="0.01" placeholder="0.00" />
        </div>
        <div class="ingredient-field ingredient-field--half">
          <label class="ingredient-field__label">Unit</label>
          <ng-select [items]="ingredientServingUnits" bindLabel="displayLabel" bindValue="servingUnitMasterId"
            [(ngModel)]="selectedServingUnitId" [clearable]="true" appendTo="body"
            placeholder="Select unit" notFoundText="No units found"></ng-select>
        </div>
      </div>
    </div>
    <div class="saru-subdialog__footer">
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--cancel" (click)="closeIngredientDialog()">Cancel</button>
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--submit" (click)="saveIngredient()"
        [disabled]="!selectedIngredientId || !ingredientAmount || !selectedServingUnitId">Save</button>
    </div>
  </div>
</ng-template>

<!-- Health group picker -->
<ng-template #healthGroupModalTpl>
  <div class="saru-subdialog">
    <div class="saru-subdialog__header">
      <div class="saru-subdialog__header-icon"><i data-lucide="layers"></i></div>
      <div style="flex:1">
        <h5 class="saru-subdialog__title">Add nutrient groups</h5>
        <p class="saru-hint mb-0">Choose one or more groups to add health condition tags.</p>
      </div>
      <button type="button" class="saru-subdialog__close" (click)="closeHealthGroupModal()" aria-label="Close">
        <i data-lucide="x"></i>
      </button>
    </div>
    <div class="saru-subdialog__body">
      <input class="saru-input mb-3" placeholder="Search groups..." [(ngModel)]="healthModalSearch" />
      <div class="health-modal-list" *ngIf="availableNutrientGroupsForModal.length; else noHealthGroups">
        <label class="health-modal-item" *ngFor="let g of availableNutrientGroupsForModal"
          [class.is-selected]="isHealthModalSelected(g.id)">
          <input type="checkbox" [checked]="isHealthModalSelected(g.id)"
            (change)="toggleHealthModalSelection(g.id)" />
          <span>{{ g.name }}</span>
        </label>
      </div>
      <ng-template #noHealthGroups>
        <p class="saru-hint">No groups available (all already added, or masters not loaded).</p>
      </ng-template>
    </div>
    <div class="saru-subdialog__footer">
      <p class="saru-hint mb-0" style="margin-right:auto">
        {{ healthModalSelection.size ? healthModalSelection.size + ' selected' : 'Select at least one group to continue' }}
      </p>
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--cancel" (click)="closeHealthGroupModal()">Cancel</button>
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--submit"
        (click)="confirmHealthGroups()" [disabled]="!healthModalSelection.size">+ Add selected</button>
    </div>
  </div>
</ng-template>

<!-- Supplement UOM picker -->
<ng-template #uomDialogTpl>
  <div class="saru-subdialog">
    <div class="saru-subdialog__header">
      <div class="saru-subdialog__header-icon"><i data-lucide="layout-grid"></i></div>
      <h5 class="saru-subdialog__title">Add Supplement UOM</h5>
      <button type="button" class="saru-subdialog__close" (click)="closeUomDialog()" aria-label="Close">
        <i data-lucide="x"></i>
      </button>
    </div>
    <div class="saru-subdialog__body">
      <div class="uom-modal-intro">
        <p class="mb-0">Select a category — all subcategories are added automatically.</p>
      </div>
      <div class="text-center py-4 text-muted" *ngIf="productUomLoading && !productUomCategories.length">
        Loading categories...
      </div>
      <div class="uom-modal-grid" *ngIf="productUomCategories.length">
        <div class="uom-modal-grid__item" *ngFor="let cat of productUomCategories; let i = index">
          <input type="checkbox" class="sr-only" [id]="'fp-bulk-uom-' + cat.id"
            [checked]="cat.selected" [disabled]="cat.adding"
            (change)="onUomCategoryToggle(cat)" />
          <label class="uom-modal-card" [for]="'fp-bulk-uom-' + cat.id"
            [class.is-selected]="cat.selected"
            [class.is-adding]="cat.adding"
            [style.borderColor]="cat.selected ? '#6D35E8' : getUomCardTheme(i, cat.name).borderColor"
            [style.background]="cat.selected ? '#F5F3FF' : '#FFFFFF'">
            <span class="uom-modal-card__radio">
              <i data-lucide="check" *ngIf="cat.selected"></i>
            </span>
            <span class="uom-modal-card__icon"
              [style.backgroundColor]="cat.selected ? '#EDE9FE' : getUomCardTheme(i, cat.name).iconBg">
              <span class="uom-modal-card__glyph"
                [style.color]="cat.selected ? '#6D35E8' : getUomCardTheme(i, cat.name).iconColor"
                [innerHTML]="getUomCardIconMarkup(getUomCardTheme(i, cat.name))"></span>
            </span>
            <span class="uom-modal-card__name">{{ cat.name }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="saru-subdialog__footer">
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--cancel" (click)="closeUomDialog()">Cancel</button>
      <button type="button" class="saru-subdialog__btn saru-subdialog__btn--submit" (click)="closeUomDialog()">
        <i data-lucide="check"></i> Done
      </button>
    </div>
  </div>
</ng-template>
